var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gap-column-xs"},[_c('div',{staticClass:"row-text",class:{
      'active': _vm.value
  }},[_c('BaseIcon',{attrs:{"size":"sm","icon":_vm.value ? _vm.activeIcon : _vm.icon}}),_c('div',{staticClass:"qrw-label-md",class:{
      bold: _vm.value
    }},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1),_c('BaseBetaToggle',{staticClass:"row-toggle",attrs:{"size":"sm","value":_vm.value},on:{"input":nv => _vm.$emit('input', nv)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }